import moment from 'moment';

function SearchBin(data) {
    this.tableDataSearch = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

SearchBin.prototype = Object.assign(SearchBin.prototype, {
    createTableData(tableDataSearch) {
        return (
            tableDataSearch &&
            tableDataSearch.recentResults &&
            tableDataSearch.recentResults.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data && data.totalRecordCount) {
            const {
                hasNextPage,
                hasPreviousPage,
                pageNumber,
                pageSize,
                sortingCriteria,
                totalNumberOfPages,
                totalRecordCount,
            } = data;
            return {
                hasNextPage,
                hasPreviousPage,
                pageNumber,
                pageSize,
                sortingCriteria,
                totalNumberOfPages,
                totalNumberOfRecords: totalRecordCount || 0,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            binBlocked,
            binHead,
            cardNature,
            cardType,
            created,
            emiBin,
            isDomestic,
            issuingBank,
            lastUpdated,
        } = row;
        return {
            binBlocked: this.formatBoolean(binBlocked),
            binHead: binHead || '-',
            cardNature: cardNature || '-',
            cardType: cardType || '-',
            created: this.formatData(created) || '-',
            emiBin: this.formatBoolean(emiBin),
            isDomestic: this.formatBoolean(isDomestic),
            issuingBank: issuingBank || '-',
            lastUpdated: this.formatData(lastUpdated) || '-',
        };
    },
    formatData(date) {
        return moment(date).format('DD/MM/YYYY');
    },

    formatBoolean(data) {
        if (data === true) {
            return 'True';
        } else if (data === false) {
            return 'False';
        }
        return '-';
    },
});

export default SearchBin;
